import { GrowthCategory } from '@mc/api'
import { useStaticData } from '@mc/static-data-react'

export const SubcategoryPageBrowseText = ({
  defaultText,
}: {
  defaultText: string
}) => {
  const { primaryCategory } = useStaticData<{
    primaryCategory: GrowthCategory | null
  }>()
  const title = primaryCategory?.name ?? defaultText

  return <span>{title}</span>
}
